import { render, staticRenderFns } from "./invitation.vue?vue&type=template&id=4be33a1b&scoped=true"
import script from "./invitation.vue?vue&type=script&lang=js"
export * from "./invitation.vue?vue&type=script&lang=js"
import style0 from "./invitation.vue?vue&type=style&index=0&id=4be33a1b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be33a1b",
  null
  
)

export default component.exports